"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderAssignmentSchema = void 0;
exports.PlaceholderAssignmentSchema = {
    "$id": "https://www.redbull.com/schemas/placeholder-assignments.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "PlaceholderAssignment",
    "description": "Stores assignments for placeholders used for missing resources",
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:placeholder-assignments"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:placeholder-assignments:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "required": [
                "replacementFor"
            ],
            "properties": {
                "replacementFor": {
                    "description": "Sets the type of the to-be-replaced resource. E.g. `rrn:content:images`",
                    "type": "string"
                }
            }
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "required": [
                "placeholderResource"
            ],
            "properties": {
                "placeholderResource": {
                    "type": "object",
                    "description": "The asset that the missing resource will be replaced with.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    }
                }
            }
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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